import { render, staticRenderFns } from "./TwoFactorDialog.vue?vue&type=template&id=511b5020"
import script from "./TwoFactorDialog.vue?vue&type=script&lang=ts"
export * from "./TwoFactorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports